export var EMapType;
(function (EMapType) {
    EMapType["ROADMAP"] = "ROADMAP";
    EMapType["SATELLITE"] = "SATELLITE";
    EMapType["TERRAIN"] = "TERRAIN";
    EMapType["HYBRID"] = "HYBRID";
})(EMapType || (EMapType = {}));
